import { Box, Button, Flex } from "@chakra-ui/react";
import React from "react";
import DateRangePicker from "./dateRangePicker";

const OverviewFilter = ({ onApply, payout }) => {
  const [filterParams, setFilterParams] = React.useState({});
  const handleFilterData = (key, value) => {
    const params = { ...filterParams };
    if (key === "app") {
      params.appEnabled = !filterParams.appEnabled;
    } else if (key === "partner") {
      params.partnerEnabled = !filterParams.partnerEnabled;
    } else {
      params.from = value?.from;
      params.to = value?.to;
    }
    console.log("filter params", params);
    onApply(params);
    setFilterParams({
      ...params,
    });
  };

  return (
    <Box>
      <Flex justifyContent={"center"}>
        {" "}
        <DateRangePicker onApply={handleFilterData} />
        {payout ? (
          <Button variant="solid" colorScheme="green" onClick={payout}>
            Create Payout
          </Button>
        ) : (
          <></>
        )}
      </Flex>
    </Box>
  );
};

export default OverviewFilter;
